import { useFormik } from "formik";
import * as Yup from "yup";
import useValidations from "../../../../utils/hooks/useValidations";
import { useGetFilterBasicDataQuery } from "../../../../store/queries/Admin";

const useSendExcelData = ({
  sendExcelData,
  isWalletTransaction,
  isBestSeller,
  isUserList,
}) => {
 
  const { emailRegExp } = useValidations();
  const { data: orderBasicData = {} } = useGetFilterBasicDataQuery();
  const validation = Yup.object({
    email: Yup.string()
      .trim()
      .required("Enter  Email ID")
      .matches(emailRegExp, "Enter Valid Email ID"),
  });
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validation,
    onSubmit: (values) => {
      if (values?.email) {
        sendExcelData(values);
      }
    },
  });
  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };

  return { formik, getFieldError };
};

export default useSendExcelData;
